import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { authConfig } from '@app/auth.config';
import { environment } from '@envs/environment';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private oauthService: OAuthService,
  ) {
    this.configureAuth();
  }

  private configureAuth(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.oauthService.configure(authConfig);
    if (environment.production) {
      this.oauthService.loadDiscoveryDocument();
    }
  }

  getToken(): any {
    return this.oauthService.getIdToken();
  }

  login(): void {
    this.oauthService.initLoginFlow();
  }
}
